import { AnyIfEmpty } from "react-redux";
import {
    GET_CONCIERGE_REQUEST,
    GET_CONCIERGE_SUCCESS,
    GET_CONCIERGE_FAILURE,
} from "../constants/concierge.constants";

const initialState = {
    loading: false,
    data: [],
    error: "",
    count: 0,
};

export const conciergeReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {

        case GET_CONCIERGE_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_CONCIERGE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: "",
            };

        case GET_CONCIERGE_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};